// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3gbR9","fileBtn":"File_fileBtn__1vD3h","closeBtn":"File_closeBtn__3odk4","fileSelected":"File_fileSelected__1LUun","disabled":"File_disabled__3Micb"};